// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.campaignCreate .campaign-container {
    margin: 0 auto;
    font-family: system-ui, -apple-system, sans-serif;
}

.campaignCreate .progress-steps {
    display: flex;
    justify-content: space-between;
    margin-bottom: 3rem;
    position: relative;
    z-index: 0;
}

.campaignCreate .progress-steps::before {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: 5px;
    width: 94%;
    background: #67676726;
    z-index: 0;
    left: 40px;
}

.campaignCreate .step {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    position: relative;
    z-index: 1;
    top: 14px;
}

.campaignCreate .step-icon {
    width: 48px;
    height: 48px;
    background: #89C19B;
    border: 2px solid #89C19B;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
}

.campaignCreate .step.active .step-icon {
    background: #6B8E76;
    border-color: #6B8E76;
    color: #064e3b;
}

.campaignCreate .step span {
    color: #64748b;
    font-size: 0.875rem;
    font-weight: 500;
}

.campaignCreate .step.active span {
    color: #064e3b;
}

.campaignCreate .form-content {
    background: white;
    padding: 20px;
    border-radius: 0.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.campaignCreate .upload-section {
    margin: 2rem 0;
}

.upload-box {
    display: flex;
    flex-direction: column;
    /* Stack items vertically */
    justify-content: center;
    /* Center content horizontally */
    align-items: center;
    /* Center content vertically */
    width: 100%;
    /* Adjust width as per requirement */
    height: 200px;
    /* Adjust height as per requirement */
    border: 2px dashed rgba(107, 142, 118, 1);
    /* Dashed border for upload area */
    border-radius: 8px;
    /* Rounded corners */
    position: relative;
    /* Optional for positioning inside parent */
}

.upload-icon {
    max-width: 100px;
    /* Limit the image size */
    max-height: 100px;
    /* Adjust as needed */
    opacity: 0.8;
    /* Slight transparency for the icon */
    margin-bottom: 8px;
    /* Add space between image and text */
}

.upload-text {
    font-size: 16px;
    /* Text size */
    font-weight: 500;
    /* Medium weight for better visibility */
    color: rgba(103, 103, 103, 1);
    ;
    /* Match text color with your theme */
    font-family: Poppins, "sans-serif";
    /* Use Poppins font */
    text-align: center;
    /* Center the text */
}

.upload-text strong {
    color: rgba(107, 142, 118, 1);
    font-weight: 400;
    font-size: 20px;
}

.campaignCreate .browse-text {
    color: #059669;
    cursor: pointer;
}

.campaignCreate .supported-text {
    font-size: 0.875rem;
    margin-top: 0.5rem;
}

.campaignCreate .form-group {
    margin-bottom: 1.5rem;
}

.campaignCreate .form-group label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: rgba(103, 103, 103, 1);
    ;
}

.campaignCreate .form-group input,
.campaignCreate .form-group select,
.campaignCreate .form-group textarea {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.375rem;
    font-size: 1rem;
    color: #1f2937;
}

.campaignCreate .form-group textarea {
    resize: vertical;
}

.campaignCreate .navigation-buttons {
    display: flex;
    justify-content: flex-end;
    margin-top: 2rem;
    padding: 1rem 0;
    gap: 10px;
}

.campaignCreate .prev-button,
.campaignCreate .next-button {
    padding: 0.75rem 1.5rem;
    border-radius: 0.375rem;
    font-weight: 500;
    transition: all 0.2s;
}

.campaignCreate .prev-button {
    background: white;
    border: 1px solid #e2e8f0;
    color: #64748b;
}

.campaignCreate .prev-button:hover:not(:disabled) {
    background: #f8fafc;
    border-color: #94a3b8;
}

.campaignCreate .next-button {
    background: #059669;
    border: none;
    color: white;
}

.campaignCreate .next-button:hover:not(:disabled) {
    background: #047857;
}

.campaignCreate .prev-button:disabled,
.campaignCreate .next-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}










.timeline-container {
    padding: 2rem 0;
}

.timeline-weeks {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    position: relative;
}

.timeline-weeks::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 2px;
    background-color: #e5e7eb;
    z-index: 0;
}

.week-marker {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    z-index: 1;
    background-color: #f9fafb;
    padding: 0 0.5rem;
}

.marker {
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 12px solid #86efac;
}

.week-text {
    font-size: 0.875rem;
    color: #6b7280;
}

.platform-section {
    margin-top: 2rem;
}

.platform-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #374151;
    margin-bottom: 1rem;
}

.content-type {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;
    padding: 0.5rem;
    border-radius: 0.5rem;
}

.content-checkbox {
    width: 1.25rem;
    height: 1.25rem;
    border: 2px solid #d1d5db;
    border-radius: 4px;
    cursor: pointer;
}

h2.Title.target-audience {
    color: rgba(107, 71, 80, 1);
    font-family: 'Poppins', sans-serif;
    /* Poppins as the primary font */
    font-size: 32px;
    font-weight: 500;


}

.content-label {
    flex: 1 1;
    font-size: 1rem;
    color: #4b5563;
}

.quantity-control {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background-color: #f3f4f6;
    padding: 0.25rem;
    border-radius: 0.5rem;
}

.quantity-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border: none;
    background-color: #86efac;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1.25rem;
    line-height: 1;
}

.quantity-button:disabled {
    background-color: #d1d5db;
    cursor: not-allowed;
}

.quantity-value {
    min-width: 24px;
    text-align: center;
    font-size: 0.875rem;
    color: #374151;
}

.age-group-container {
    padding: 20px;
    font-family: 'Poppins', sans-serif;
    /* Poppins as the primary font */
}

.age {
    color: #666;
    font-size: 24px;
    font-weight: 500;
}

.age-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.age-button {
    padding: 8px 16px;
    border: 1px solid rgba(107, 142, 118, 1);
    background-color: white;
    border-radius: 20px;
    cursor: pointer;
    font-size: 14px;
    color: rgba(103, 103, 103, 1);
    font-weight: 500;

    transition: all 0.2s ease;
    outline: none;
}

.age-button:hover {
    background-color: #f5f5f5;
}

.age-button.selected {
    background-color: #f0f0f0;
    border-color: #d0d0d0;
    color: #333;
}

.center-container {
    display: flex;
    justify-content: center;
    align-items: center;

}

/* Custom Checkbox */
.custom-checkbox {
    position: relative;
    width: 20px;
    height: 20px;
    border: 2px solid #6B4C67;
    border-radius: 4px;
    background-color: #fff;
    display: inline-block;
    cursor: pointer;
}

.custom-checkbox:checked {
    background-color: #6B4C67;
}

/* Only apply border around the counter button area */
.counter-container {
    display: flex;
    align-items: center;
    border: 1px solid #6B4C67;
    padding: 3px;
    border-radius: 5px;
}

.list-group-item.d-flex {
    border: none;
}

.counter-button {
    background: rgba(107, 142, 118, 1);
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    font-size: 16px;
}



.counter-value {
    font-size: 16px;
    margin: 0 10px;
    color: #6B4C67;
}

/* Style for the entire content */
.content-container {
    width: 100%;
    max-width: 800px;
    /* Set maximum width */
    padding: 20px;
}

/* Title Styling */
.content-container h2 {
    color: rgba(103, 103, 103, 1);
    font-family: Poppins, "sans-serif";
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 20px;
    text-align: center;
    padding-bottom: 10px;
}

label.ms-3.text-secondary {
    color: rgba(103, 103, 103, 1);
    font-family: Poppins, "sans-serif";
    font-weight: 500;
    font-size: 24px;


}

/* Button and label alignment */
.list-group-item .ms-3 {
    margin-left: 15px;
}

.list-group-item {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    margin-bottom: 15px;
    align-items: center;
}

.list-group-item label {
    font-size: 16px;
    color: #6B4C67;
}


/* Custom checkbox styles */
input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid #fcd9e2;
    border-radius: 50%;
    outline: none;
    cursor: pointer;
    position: relative;
    transition: all 0.2s ease;
}

input[type="checkbox"]:checked {
    background-color: rgba(107, 142, 118, 1) !important;

}

input[type="checkbox"]:checked::after {
    content: "";
    position: absolute;
    left: 6px;
    top: 3px;
    width: 4px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

/* Button hover effects */
button {
    transition: all 0.2s ease;
}



/* Counter controls */
.counter-controls {
    background-color: white;
    border-radius: 9999px;
    padding: 2px;
    display: flex;
    align-items: center;
    border: 1px solid #fce7f3;
}

.counter-button {
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: white;
    transition: all 0.2s ease;
}

.counter-value {
    width: 32px;
    text-align: center;
    font-size: 18px;
    color: #4b5563;
}



@media (max-width: 600px) {
    .age-buttons {
        gap: 8px;
    }

    .age-button {
        padding: 6px 12px;
        font-size: 13px;
    }
}




@media(max-width:767px) {
    .campaignCreate .step.active .step-icon img {
        height: 20px;
        width: 20px;
    }

    .campaignCreate .step-icon {
        width: 32px;
        height: 32px;
    }

    .campaignCreate .progress-steps::before {
        width: 89%;
    }
}

@media (max-width: 575px) {}

/* campaign */
.secret-santa-container {
    max-width: 800px;
    margin: 0 auto;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.detail-title {
    color: rgba(107, 142, 118, 1);
    font-size: 26px;
    font-weight: 500;
    margin-bottom: 2px;
    font-family: Poppins, "sans-serif";
    padding: 0;
}


.subtitle {
    color: rgba(103, 103, 103, 1);
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 500;
}

.description-section p {
    color: #555;
    line-height: 1.6;
}

.feature-item {
    display: flex;
    margin-bottom: 16px;
}

.bullet {
    margin-right: 10px;
    color: #4a6741;
}

.feature-item p {
    margin: 0;
    color: #555;
}

.feature-item strong {
    color: #333;
}

.info-section h2 {
    font-size: 18px;
    color: rgba(107, 142, 118, 1);
    margin-bottom: 20px;
}

.info-content {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 15px;
}

.info-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
}

.audience-info {
    display: flex;
    align-items: center;
    gap: 12px;
}

.tags {
    display: flex;
    gap: 8px;
}

.tag {
    padding: 2px 8px;
    background-color: #f0f0f0;
    border-radius: 4px;
    font-size: 12px;
    color: #666;
}

.publish-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #eee;
}

.form-check-label {
    color: #666;
}

.btn-success {
    background-color: #4a6741;
    border-color: #4a6741;
}

.btn-success:hover {
    background-color: #3d5636;
    border-color: #3d5636;
}

.btn-outline-secondary {
    color: #666;
    border-color: #ddd;
}

.btn-outline-secondary:hover {
    background-color: #f5f5f5;
    color: #333;
    border-color: #ccc;
}

@media (max-width: 576px) {
    .publish-section {
        flex-direction: column;
        gap: 20px;
    }

    .button-group {
        width: 100%;
        display: flex;
        gap: 10px;
    }

    .button-group .btn {
        flex: 1 1;
    }

    .audience-info {
        flex-direction: column;
        align-items: flex-start;
    }
}

p.text-gray-blank-600.mb-8 {

    color: #676767;
    font-size: 24px;
    padding: 0 30px;
    max-width: 100%;
    line-height: 37px;

}
`, "",{"version":3,"sources":["webpack://./src/InsocialOrbit/Brand/Campaign/Campaign.css"],"names":[],"mappings":";AACA;IACI,cAAc;IACd,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,gCAAgC;IAChC,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,oCAAoC;IACpC,aAAa;IACb,qCAAqC;IACrC,yCAAyC;IACzC,kCAAkC;IAClC,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,wCAAwC;IACxC,6BAA6B;;IAE7B,qCAAqC;IACrC,kCAAkC;IAClC,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,6BAA6B;;AAEjC;;AAEA;;;IAGI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,SAAS;AACb;;AAEA;;IAEI,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;;;;;;;;;;AAWA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,gCAAgC;IAChC,eAAe;IACf,gBAAgB;;;AAGpB;;AAEA;IACI,SAAO;IACP,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,wCAAwC;IACxC,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;;IAEhB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,qDAAqD;AACrD;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;;;;AAIA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA,iCAAiC;AACjC;IACI,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;AACjB;;AAEA,kBAAkB;AAClB;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;;;AAGnB;;AAEA,+BAA+B;AAC/B;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;;AAGA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,mDAAmD;;AAEvD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;AAC7B;;;;AAIA,qBAAqB;AACrB;IACI,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;;;AAIA;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;;;;AAKA;IACI;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,2BAA2B;;AAE3B,aAAa;AACb;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;IAClC,UAAU;AACd;;;AAGA;IACI,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,aAAa;QACb,SAAS;IACb;;IAEA;QACI,SAAO;IACX;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,eAAe;IACf,eAAe;IACf,iBAAiB;;AAErB","sourcesContent":["\n.campaignCreate .campaign-container {\n    margin: 0 auto;\n    font-family: system-ui, -apple-system, sans-serif;\n}\n\n.campaignCreate .progress-steps {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 3rem;\n    position: relative;\n    z-index: 0;\n}\n\n.campaignCreate .progress-steps::before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    height: 5px;\n    width: 94%;\n    background: #67676726;\n    z-index: 0;\n    left: 40px;\n}\n\n.campaignCreate .step {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.5rem;\n    position: relative;\n    z-index: 1;\n    top: 14px;\n}\n\n.campaignCreate .step-icon {\n    width: 48px;\n    height: 48px;\n    background: #89C19B;\n    border: 2px solid #89C19B;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #64748b;\n}\n\n.campaignCreate .step.active .step-icon {\n    background: #6B8E76;\n    border-color: #6B8E76;\n    color: #064e3b;\n}\n\n.campaignCreate .step span {\n    color: #64748b;\n    font-size: 0.875rem;\n    font-weight: 500;\n}\n\n.campaignCreate .step.active span {\n    color: #064e3b;\n}\n\n.campaignCreate .form-content {\n    background: white;\n    padding: 20px;\n    border-radius: 0.5rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.campaignCreate .upload-section {\n    margin: 2rem 0;\n}\n\n.upload-box {\n    display: flex;\n    flex-direction: column;\n    /* Stack items vertically */\n    justify-content: center;\n    /* Center content horizontally */\n    align-items: center;\n    /* Center content vertically */\n    width: 100%;\n    /* Adjust width as per requirement */\n    height: 200px;\n    /* Adjust height as per requirement */\n    border: 2px dashed rgba(107, 142, 118, 1);\n    /* Dashed border for upload area */\n    border-radius: 8px;\n    /* Rounded corners */\n    position: relative;\n    /* Optional for positioning inside parent */\n}\n\n.upload-icon {\n    max-width: 100px;\n    /* Limit the image size */\n    max-height: 100px;\n    /* Adjust as needed */\n    opacity: 0.8;\n    /* Slight transparency for the icon */\n    margin-bottom: 8px;\n    /* Add space between image and text */\n}\n\n.upload-text {\n    font-size: 16px;\n    /* Text size */\n    font-weight: 500;\n    /* Medium weight for better visibility */\n    color: rgba(103, 103, 103, 1);\n    ;\n    /* Match text color with your theme */\n    font-family: Poppins, \"sans-serif\";\n    /* Use Poppins font */\n    text-align: center;\n    /* Center the text */\n}\n\n.upload-text strong {\n    color: rgba(107, 142, 118, 1);\n    font-weight: 400;\n    font-size: 20px;\n}\n\n.campaignCreate .browse-text {\n    color: #059669;\n    cursor: pointer;\n}\n\n.campaignCreate .supported-text {\n    font-size: 0.875rem;\n    margin-top: 0.5rem;\n}\n\n.campaignCreate .form-group {\n    margin-bottom: 1.5rem;\n}\n\n.campaignCreate .form-group label {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n    color: rgba(103, 103, 103, 1);\n    ;\n}\n\n.campaignCreate .form-group input,\n.campaignCreate .form-group select,\n.campaignCreate .form-group textarea {\n    width: 100%;\n    padding: 0.75rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 0.375rem;\n    font-size: 1rem;\n    color: #1f2937;\n}\n\n.campaignCreate .form-group textarea {\n    resize: vertical;\n}\n\n.campaignCreate .navigation-buttons {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 2rem;\n    padding: 1rem 0;\n    gap: 10px;\n}\n\n.campaignCreate .prev-button,\n.campaignCreate .next-button {\n    padding: 0.75rem 1.5rem;\n    border-radius: 0.375rem;\n    font-weight: 500;\n    transition: all 0.2s;\n}\n\n.campaignCreate .prev-button {\n    background: white;\n    border: 1px solid #e2e8f0;\n    color: #64748b;\n}\n\n.campaignCreate .prev-button:hover:not(:disabled) {\n    background: #f8fafc;\n    border-color: #94a3b8;\n}\n\n.campaignCreate .next-button {\n    background: #059669;\n    border: none;\n    color: white;\n}\n\n.campaignCreate .next-button:hover:not(:disabled) {\n    background: #047857;\n}\n\n.campaignCreate .prev-button:disabled,\n.campaignCreate .next-button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n\n\n\n\n\n\n\n\n\n.timeline-container {\n    padding: 2rem 0;\n}\n\n.timeline-weeks {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n    position: relative;\n}\n\n.timeline-weeks::after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background-color: #e5e7eb;\n    z-index: 0;\n}\n\n.week-marker {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.5rem;\n    z-index: 1;\n    background-color: #f9fafb;\n    padding: 0 0.5rem;\n}\n\n.marker {\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-bottom: 12px solid #86efac;\n}\n\n.week-text {\n    font-size: 0.875rem;\n    color: #6b7280;\n}\n\n.platform-section {\n    margin-top: 2rem;\n}\n\n.platform-title {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #374151;\n    margin-bottom: 1rem;\n}\n\n.content-type {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    margin-bottom: 1rem;\n    padding: 0.5rem;\n    border-radius: 0.5rem;\n}\n\n.content-checkbox {\n    width: 1.25rem;\n    height: 1.25rem;\n    border: 2px solid #d1d5db;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\nh2.Title.target-audience {\n    color: rgba(107, 71, 80, 1);\n    font-family: 'Poppins', sans-serif;\n    /* Poppins as the primary font */\n    font-size: 32px;\n    font-weight: 500;\n\n\n}\n\n.content-label {\n    flex: 1;\n    font-size: 1rem;\n    color: #4b5563;\n}\n\n.quantity-control {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background-color: #f3f4f6;\n    padding: 0.25rem;\n    border-radius: 0.5rem;\n}\n\n.quantity-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border: none;\n    background-color: #86efac;\n    color: white;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 1.25rem;\n    line-height: 1;\n}\n\n.quantity-button:disabled {\n    background-color: #d1d5db;\n    cursor: not-allowed;\n}\n\n.quantity-value {\n    min-width: 24px;\n    text-align: center;\n    font-size: 0.875rem;\n    color: #374151;\n}\n\n.age-group-container {\n    padding: 20px;\n    font-family: 'Poppins', sans-serif;\n    /* Poppins as the primary font */\n}\n\n.age {\n    color: #666;\n    font-size: 24px;\n    font-weight: 500;\n}\n\n.age-buttons {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n}\n\n.age-button {\n    padding: 8px 16px;\n    border: 1px solid rgba(107, 142, 118, 1);\n    background-color: white;\n    border-radius: 20px;\n    cursor: pointer;\n    font-size: 14px;\n    color: rgba(103, 103, 103, 1);\n    font-weight: 500;\n\n    transition: all 0.2s ease;\n    outline: none;\n}\n\n.age-button:hover {\n    background-color: #f5f5f5;\n}\n\n.age-button.selected {\n    background-color: #f0f0f0;\n    border-color: #d0d0d0;\n    color: #333;\n}\n\n.center-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n/* Custom Checkbox */\n.custom-checkbox {\n    position: relative;\n    width: 20px;\n    height: 20px;\n    border: 2px solid #6B4C67;\n    border-radius: 4px;\n    background-color: #fff;\n    display: inline-block;\n    cursor: pointer;\n}\n\n.custom-checkbox:checked {\n    background-color: #6B4C67;\n}\n\n/* Only apply border around the counter button area */\n.counter-container {\n    display: flex;\n    align-items: center;\n    border: 1px solid #6B4C67;\n    padding: 3px;\n    border-radius: 5px;\n}\n\n.list-group-item.d-flex {\n    border: none;\n}\n\n.counter-button {\n    background: rgba(107, 142, 118, 1);\n    border: none;\n    padding: 5px 10px;\n    cursor: pointer;\n    font-size: 16px;\n}\n\n\n\n.counter-value {\n    font-size: 16px;\n    margin: 0 10px;\n    color: #6B4C67;\n}\n\n/* Style for the entire content */\n.content-container {\n    width: 100%;\n    max-width: 800px;\n    /* Set maximum width */\n    padding: 20px;\n}\n\n/* Title Styling */\n.content-container h2 {\n    color: rgba(103, 103, 103, 1);\n    font-family: Poppins, \"sans-serif\";\n    font-size: 24px;\n    font-weight: 500;\n    margin-bottom: 20px;\n    text-align: center;\n    padding-bottom: 10px;\n}\n\nlabel.ms-3.text-secondary {\n    color: rgba(103, 103, 103, 1);\n    font-family: Poppins, \"sans-serif\";\n    font-weight: 500;\n    font-size: 24px;\n\n\n}\n\n/* Button and label alignment */\n.list-group-item .ms-3 {\n    margin-left: 15px;\n}\n\n.list-group-item {\n    display: flex;\n    justify-content: space-between;\n    padding: 10px;\n    margin-bottom: 15px;\n    align-items: center;\n}\n\n.list-group-item label {\n    font-size: 16px;\n    color: #6B4C67;\n}\n\n\n/* Custom checkbox styles */\ninput[type=\"checkbox\"] {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    width: 20px;\n    height: 20px;\n    border: 2px solid #fcd9e2;\n    border-radius: 50%;\n    outline: none;\n    cursor: pointer;\n    position: relative;\n    transition: all 0.2s ease;\n}\n\ninput[type=\"checkbox\"]:checked {\n    background-color: rgba(107, 142, 118, 1) !important;\n\n}\n\ninput[type=\"checkbox\"]:checked::after {\n    content: \"\";\n    position: absolute;\n    left: 6px;\n    top: 3px;\n    width: 4px;\n    height: 8px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n}\n\n/* Button hover effects */\nbutton {\n    transition: all 0.2s ease;\n}\n\n\n\n/* Counter controls */\n.counter-controls {\n    background-color: white;\n    border-radius: 9999px;\n    padding: 2px;\n    display: flex;\n    align-items: center;\n    border: 1px solid #fce7f3;\n}\n\n.counter-button {\n    width: 35px;\n    height: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    color: white;\n    transition: all 0.2s ease;\n}\n\n.counter-value {\n    width: 32px;\n    text-align: center;\n    font-size: 18px;\n    color: #4b5563;\n}\n\n\n\n@media (max-width: 600px) {\n    .age-buttons {\n        gap: 8px;\n    }\n\n    .age-button {\n        padding: 6px 12px;\n        font-size: 13px;\n    }\n}\n\n\n\n\n@media(max-width:767px) {\n    .campaignCreate .step.active .step-icon img {\n        height: 20px;\n        width: 20px;\n    }\n\n    .campaignCreate .step-icon {\n        width: 32px;\n        height: 32px;\n    }\n\n    .campaignCreate .progress-steps::before {\n        width: 89%;\n    }\n}\n\n@media (max-width: 575px) {}\n\n/* campaign */\n.secret-santa-container {\n    max-width: 800px;\n    margin: 0 auto;\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.detail-title {\n    color: rgba(107, 142, 118, 1);\n    font-size: 26px;\n    font-weight: 500;\n    margin-bottom: 2px;\n    font-family: Poppins, \"sans-serif\";\n    padding: 0;\n}\n\n\n.subtitle {\n    color: rgba(103, 103, 103, 1);\n    font-size: 20px;\n    margin-bottom: 20px;\n    font-weight: 500;\n}\n\n.description-section p {\n    color: #555;\n    line-height: 1.6;\n}\n\n.feature-item {\n    display: flex;\n    margin-bottom: 16px;\n}\n\n.bullet {\n    margin-right: 10px;\n    color: #4a6741;\n}\n\n.feature-item p {\n    margin: 0;\n    color: #555;\n}\n\n.feature-item strong {\n    color: #333;\n}\n\n.info-section h2 {\n    font-size: 18px;\n    color: rgba(107, 142, 118, 1);\n    margin-bottom: 20px;\n}\n\n.info-content {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-top: 15px;\n}\n\n.info-icon {\n    width: 24px;\n    height: 24px;\n    object-fit: contain;\n}\n\n.audience-info {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.tags {\n    display: flex;\n    gap: 8px;\n}\n\n.tag {\n    padding: 2px 8px;\n    background-color: #f0f0f0;\n    border-radius: 4px;\n    font-size: 12px;\n    color: #666;\n}\n\n.publish-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 30px;\n    padding-top: 20px;\n    border-top: 1px solid #eee;\n}\n\n.form-check-label {\n    color: #666;\n}\n\n.btn-success {\n    background-color: #4a6741;\n    border-color: #4a6741;\n}\n\n.btn-success:hover {\n    background-color: #3d5636;\n    border-color: #3d5636;\n}\n\n.btn-outline-secondary {\n    color: #666;\n    border-color: #ddd;\n}\n\n.btn-outline-secondary:hover {\n    background-color: #f5f5f5;\n    color: #333;\n    border-color: #ccc;\n}\n\n@media (max-width: 576px) {\n    .publish-section {\n        flex-direction: column;\n        gap: 20px;\n    }\n\n    .button-group {\n        width: 100%;\n        display: flex;\n        gap: 10px;\n    }\n\n    .button-group .btn {\n        flex: 1;\n    }\n\n    .audience-info {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n\np.text-gray-blank-600.mb-8 {\n\n    color: #676767;\n    font-size: 24px;\n    padding: 0 30px;\n    max-width: 100%;\n    line-height: 37px;\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
